<template>
  <!-- place -->
  <div>
    <div v-show="!hidden" class="formGroup isRequired mt15">
      <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
      <select class="input" v-model="place" @change="selectPlace">
        <option value="" disabled class="notranslate toCapitalize">{{locale.select_place}}</option>
        <option
          v-for="p in placeInfo"
          :key="p.placeId"
          :value="p.placeId"
          :disabled="p.disabled">
          {{p.name[lang]}}
        </option>
      </select>
    </div>
    <div v-if="isSelectable && current" class="statusMessage mt10">
      <span>
        {{locale.reservation_status}}: {{current.current}}/{{current.count}}
        <i v-if="isStaff && overbooking <= 0">Overbooking</i>
      </span>
    </div>
  </div>
  <!-- //place -->
</template>

<script>
export default {
  name: 'ReservationFormPlace',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'placeInfo',
    'isSelectable',
    'isStaff',
  ],
  computed: {
    current () {
      const list = this.placeInfo
      return list && list.find(x => x.placeId === this.place)
    },
    overbooking () {
      const count = this.current && this.current.count
      const current = this.current && this.current.current
      return parseInt(count) - parseInt(current)
    }
  },
  watch: {
    placeInfo: {
      deep: true,
      handler () {
        this.autoFull()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.autoFull()
    })
  },
  beforeDestroy () {
    this.place = null
    this.selectPlace()
  },
  data () {
    return {
      hidden: false,
      place: ''
    }
  },
  methods: {
    autoFull () {
      const current = this.placeInfo &&
        this.placeInfo.find(x => x.placeId === this.place)

      // 현재 선택된 place가 더 이상 선택 불가능하면 초기화
      if (current && current.disabled) {
        this.place = ''
        this.selectPlace()
      }

      const selectableList = (this.placeInfo || [])
        .filter(x => !x.disabled)

      if (this.isSelectable && selectableList.length === 1) {
        const placeId = selectableList[0].placeId

        if (this.place !== placeId) {
          this.place = placeId
          this.selectPlace()
        }

        this.hidden = true
      } else {
        this.hidden = false
      }
    },
    selectPlace () {
      this.$emit('setPlace', this.place)
    }
  }
}
</script>

<style lang="scss" scoped>
.statusMessage {
  span {
    display: inline-block;
    position: relative;
    padding: 4px 10px;
    font-size: 0.85em;
    color: $color-white;
    white-space: nowrap;
    border-radius: 50px;
    background-color: $color-green;
    i {
      margin-left: 2px;
      padding: 0 4px;
      color: $color-red;
      font-size: 0.85em;
      border-radius: 4px;
      background-color: $color-white;
      opacity: 0.9;
    }
  }
}
</style>
